export default {
    data () {
        return {
            typeOptinon:[
                {label:"影像诊断",id:0,value:0},
                {label:"手术",id:1,value:1},
                {label:"住院",id:2,value:2}
            ],
            typeSearch:null
        }
    },
    methods: {
        chioceType(data){
            console.log(data)
        }
    },
}